/**
 * Column class
 * @private
 */
export class Column {
}
